import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag, TagProps } from 'antd'
import classNames from 'classnames';
import { memo } from 'react';

type Props = {
  className?: string;
  color?: TagProps['color'];
  noTags?: boolean;
  tag?: string;
}

function AppTag({ tag, color = 'blue', noTags, className }: Props) {
  return (
    <Tag
      color={noTags ? 'default' : color}
      className={classNames("rounded-pill fw-bold", className)}
      icon={!noTags && <FontAwesomeIcon icon={solid('tag')} className="me-1" />}
    >
      {noTags ? '0 tags' : tag}
    </Tag>
  )
}

export default memo(AppTag);